<template>
  <div class="appContainer survey">
    <div class="title">
      <div class="line"></div>
      <h1>{{ $t('survey-page.header', { split: '/' }) }}</h1>
    </div>

    <h4
      class="left-border"
      v-html="$t('survey-page.description-title', { split: '/' })"
    ></h4>

    <div class="survey-container">
      <div class="survey-iframe" v-if="m_survey_template">
        <iframe
          :src="m_survey_template.applicant_survey_url"
          frameborder="0"
        ></iframe>
      </div>
    </div>

    <ScrollTopBtn />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ScrollTopBtn from '@/components/ScrollTopBtn';

export default {
  components: {
    ScrollTopBtn
  },
  computed: {
    ...mapGetters({
      m_survey_template: 'getMSurveyTemplate'
    })
  },

  methods: {},
  watch: {
    m_survey_template: function (val) {
      return val;
    }
  },

  created() {}
};
</script>

<style lang="scss">
@import './survey.scss';
</style>
